import { Col, Container, Row } from "react-bootstrap";
import { webUrl } from "../../helper/globals";

export default function PaidChannels() {
  return (
    <Container fluid>
      <Row>
        <Row style={{ textAlign: "justify" }}>
          <Col
            style={{
              display: " flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            xs={12}
            md={6}
          >
            <img src={webUrl + "/u/channel/72X52%20NEW.jpg"} alt="new movie" />
          </Col>
          <Col xs={12} md={6}>
            <Row>
              <h2>MOVIE PREMIERE channel</h2>
              <p>
                MOVIE PREMIERE channel offers copyrighted new movies from
                Mongolia and other countries with high-quality definitions. The
                movies are available in accordance with an allotted time slot.
              </p>
              <p>
                Channel number: 800
                <br />
                Price: Varies by content
              </p>
            </Row>
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: "justify" }}>
          <Col
            xs={12}
            md={6}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <img
                src="https://my.ddishtv.mn:5001/nvod/LIVE.png"
                alt="ddish live"
                width="100%"
              />
              <p>
                DDISHLIVE channel offers rock, pop, and country music concerts,
                comedy shows, film, cultural and sports events that you can
                conveniently watch anywhere from Mongolia through live
                streaming.
              </p>
              <p>
                Channel number: 900
                <br />
                Price : Varies by content
              </p>
            </div>
          </Col>
          <Col
            style={{
              display: " flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            xs={12}
            md={6}
          >
            <img
              src={webUrl + "/u/logo/Banner%20live.jpg"}
              alt="ddish live"
              style={{ marginBottom: "10px" }}
            />
          </Col>
        </Row>
        <hr />
        <Row style={{ textAlign: "justify" }}>
          <Col
            style={{
              display: " flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            xs={12}
            md={6}
          >
            <img
              src={webUrl + "/u/logo/Banner playboy.jpg"}
              alt="playboy"
              style={{ marginBottom: "10px" }}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            style={{
              display: "flex",
              marginBottom: "10px",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Row>
              <h2>Playboy</h2>
              <p>
                Playboy TV® offers premium adult programming, motion pictures,
                first-run TV shows and specials for 24/7 (Channel 901)
              </p>
            </Row>
          </Col>
        </Row>
      </Row>
    </Container>
  );
}
